
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52.76 15.33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.09 14.92H7.67a7.26 7.26 0 010-14.5h37.42a7.26 7.26 0 010 14.5zM12.15 4.5v6.38M8.97 7.69h6.36M9.9 5.45l4.5 4.49m-4.5 0l4.5-4.5m7.43-.94v6.38m-3.17-3.19h6.36m-5.44-2.24l4.5 4.49m-4.5 0l4.5-4.5m6.94-.94v6.38m-3.19-3.19h6.37m-5.43-2.24l4.5 4.49m-4.5 0l4.5-4.5m6.94-.95v6.36m-3.18-3.18h6.36m-5.43-2.25l4.5 4.5m-4.5 0l4.5-4.5","stroke":"#000","stroke-width":".82","fill":"none","fill-rule":"evenodd"}})])
          )
        }
      }
    